package com.milta.core.localization.translations.it

import com.milta.core.localization.AdminUsersStrings

internal val AdminUsers = AdminUsersStrings(
    loading = "Caricamento…",
    errorNoConnection = "Impossibile contattare il server — controlla la tua connessione.",
    errorGeneric = "Si è verificato un errore. Riprova più tardi.",
    readOnlyNotice = "🔒 Solo consultazione — nessun account può ancora essere creato, modificato o sospeso da questa schermata.",
    kpiAccountsLabel = "Account",
    kpiAccountsSubtitle = "tutti i ruoli combinati",
    kpiDriversLabel = "Autisti",
    kpiDriversSubtitle = "senza squadra propria",
    kpiPatronsLabel = "Proprietari",
    kpiPatronsOrgSingular = "organizzazione",
    kpiPatronsOrgPlural = "organizzazioni",
    kpiActiveSubsLabel = "Abbonamenti attivi",
    kpiActiveSubsSubtitle = "attivo + periodo di grazia",
    kpiAtRiskLabel = "A rischio",
    kpiAtRiskSubtitle = "prova o scaduto",
    searchPlaceholder = "Cerca per nome, email, organizzazione…",
    expandAllAction = "Espandi tutto",
    collapseAllAction = "Comprimi tutto",
    columnAccount = "Account",
    columnContact = "Contatto",
    columnType = "Tipo",
    columnAddedDate = "Aggiunto / creata il",
    columnSubscription = "Abbonamento",
    columnSince = "Dal",
    columnRenewal = "Rinn.",
    noOrganizationHeader = "Senza organizzazione",
    emptySearchResult = "Nessun account corrisponde a questa ricerca.",
    patronBadgePrefix = "Proprietario",
    createdOnPrefix = "Creata il",
    emptyTeamMessage = "Ancora nessun autista in questa squadra.",
    driverBadge = "Autista",
    addedOnPrefix = "Aggiunto il",
    viaOrganization = "Tramite organizzazione",
    accountCreatedOnUnknown = "Account creato il —",
    renewalSingular = "rinnovo",
    renewalPlural = "rinnovi",
    subscriptionNone = "Nessuno",
    subscriptionActive = "Attivo",
    subscriptionTrial = "Prova",
    subscriptionGrace = "Grazia",
    subscriptionExpiredStatus = "Scaduto",
    subscriptionCancelled = "Annullato",
    planOrganization = "Organizzazione",
    planDriver = "Autista",
)
